const BoardListView = () => {
  return (
    <div className="main-cnt">
      <div className="rd-page">페이지 준비 중 입니다...</div>
    </div>
  );
};

export default BoardListView;
